var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metric-block",class:{ 'metric-block-vertical': _vm.valuePosition === 'top' }},[_c('div',{staticClass:"metric-block-value"},[_vm._v(" "+_vm._s(_vm.metric)+" ")]),_c('TitleSection',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }